<div>
  <div>
    <h4>{{ 'Doc::CustomerInvoice:Preview' | abpLocalization }}</h4>
  </div>
  <ag-grid-angular
    class="ag-theme-digiwall w-100"
    domLayout="autoHeight"
    [defaultColDef]="defaultColDef"
    [gridOptions]="gridOptions"
    [columnDefs]="columnDefs"
    [treeData]="true"
    [getDataPath]="getDataPath"
    #grid
    [getRowClass]="getRowClass"
  >
  </ag-grid-angular>
</div>
